"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.menu = void 0;
const basic_1 = require("../basic");
const font_faces_1 = require("./font-faces");
const colors_1 = require("../basic/colors");
exports.menu = (0, basic_1.applyBase)({
    nav: {
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'center',
        '&:hover': {
            color: 'primary',
        },
    },
    headerMenu: {
        width: ['100%', 'auto'],
        backgroundColor: 'background',
        mb: [4, 0],
        '.mobile-nav-bar-list': {
            pb: 0,
        },
        alignItems: 'center',
        '> ul li:first-child': {
            pl: 0,
        },
    },
    menuLinkItem: {
        display: 'flex',
        height: '64px',
        pl: '24px',
        '&:hover + .sub-links-list, &:focus-within + .sub-links-list': {
            zIndex: '999',
            opacity: '1',
        },
    },
    subLinksListWrap: {
        position: 'absolute',
        backgroundColor: colors_1.colors.background,
        width: '100%',
        flexDirection: 'column',
        maxWidth: '1317px',
        top: '101%',
        transform: 'translateX(-50%)',
        left: '50%',
        py: 5,
        opacity: '0',
        zIndex: '-1000',
        '&:hover, &:focus-within, &:focus, &:focus-visible': {
            zIndex: '999',
            opacity: '1',
        },
    },
    subLinksList: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        alignContent: 'flex-start',
        maxWidth: '1204px',
        width: '100%',
        maxHeight: '330px',
        mx: 'auto',
        '@media screen and (max-width: 1240px)': {
            pl: '16px',
        },
    },
    navBarItem: {
        maxWidth: '380px',
        width: '100%',
        mr: '34px',
        '@media screen and (max-width: 1240px)': {
            maxWidth: '360px',
        },
        '@media screen and (max-width: 1180px)': {
            maxWidth: '300px',
        },
        '@media screen and (max-width: 981px)': {
            maxWidth: 'initial',
        },
    },
    navBarLink: Object.assign(Object.assign({ py: '10px', pr: [0, 2], mb: '-1px', width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }, font_faces_1.FONT_SIZE.NAVIGATION), { lineHeight: [null, '1.3'], '.icon': {
            fill: 'none',
            color: 'redSecondary',
            height: '24px',
            width: '24px',
        } }),
    mobileMenuModal: {
        display: 'flex',
        flexDirection: 'column',
        position: 'absolute',
        top: '56px',
        bottom: 0,
        left: 0,
        width: ['100%', '40%'],
        backgroundColor: colors_1.colors.background,
        px: 3,
        pt: 4,
        pb: 5,
        height: ['calc(100vh - 56px)', 'calc(100vh - 79px)'],
        zIndex: '999',
        overflowY: 'auto',
        borderTop: '1px solid',
        borderColor: 'borderColor',
        '.language-control': {
            mb: 4,
            '.input': Object.assign(Object.assign({}, font_faces_1.FONT_SIZE.LARGE), { pl: 0, py: '10px' }),
        },
    },
});
//# sourceMappingURL=menu.js.map